module.exports = __webpack_public_path__ + "static/media/thumb1.47bef17a.jpeg";